import { Descriptions, Link, Text } from "@/atoms"
import {
  DEFAULT_LONG_FORMAT,
  getDateFromSeconds,
  getDateInUserLocale
} from "@/helpers/date.helpers"
import { EMPTY_VALUE, OverviewCardTemplate } from "../OverviewCardTemplate"

export const SummaryCard = ({ data }: any) => {
  if (data === undefined) return null

  const { description, language, link, licenses, lastSeen } = data || {}

  const items = [
    {
      label: <Descriptions.Label>Type</Descriptions.Label>,
      children: <Text>Open Source Package</Text>
    },
    {
      label: <Descriptions.Label>Description</Descriptions.Label>,
      children: <Text ellipsis>{description || EMPTY_VALUE}</Text>
    },
    {
      label: <Descriptions.Label>Last Seen</Descriptions.Label>,
      children: getDateInUserLocale(
        getDateFromSeconds(lastSeen),
        DEFAULT_LONG_FORMAT
      )
    },
    {
      label: <Descriptions.Label>Link</Descriptions.Label>,
      children: link ? (
        <Link href={link} target="_blank" type="link">
          {link}
        </Link>
      ) : (
        EMPTY_VALUE
      )
    },
    {
      label: <Descriptions.Label>License</Descriptions.Label>,
      children: <Text ellipsis>{licenses.join(",") || EMPTY_VALUE}</Text>
    },
    {
      label: <Descriptions.Label>Language</Descriptions.Label>,
      children: <Text ellipsis>{language || EMPTY_VALUE}</Text>
    }
  ]

  return <OverviewCardTemplate title="Summary" items={items} />
}
